import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ScheduleItem, ScheduleUpdateDto, UserItem, UserItemMinimal } from 'src/app/api/models';
import { SchedulazioniService } from 'src/app/api/services';
import { ModalUserPickerComponent } from '../modal-user-picker/modal-user-picker.component';
import { enumScheduleStatus } from '../enums/schedule_status.enum';

@Component({
  selector: 'app-modal-edit-schedule',
  templateUrl: './modal-edit-schedule.component.html',
  styleUrls: ['./modal-edit-schedule.component.scss'],
})
export class ModalEditScheduleComponent implements OnInit {
  schedule: ScheduleItem;
  saving = false;
  assignedUserPickerRef: DynamicDialogRef | undefined;

  protected readonly acceptRejectOptions = [
    { label: 'Accetta', value: enumScheduleStatus.ACCETTATA },
    { label: 'Rifiuta', value: enumScheduleStatus.ANNULLATA },
  ];

  // Uniche informazioni modificabili da questa modale: tecnico assegnatario,
  // accettazione/rifiuto della schedulazione, note. Ogni altro campo non è
  // esposto: se non valorizzato non viene inviato nel body dell'update,
  // quindi il backend lo lascia invariato.
  frm = new FormGroup({
    assigned_user: new FormControl<UserItemMinimal | undefined>(undefined),
    schedule_status_id: new FormControl<number | undefined>(undefined),
    notes: new FormControl<string | undefined>(undefined),
  });

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private dialogService: DialogService,
    private scheduleService: SchedulazioniService,
    private messageService: MessageService
  ) {
    this.schedule = config.data!.schedule as ScheduleItem;
  }

  ngOnInit() {
    const currentStatusId = this.schedule.related_schedule_status?.id;
    const currentStatusIsAcceptReject = this.acceptRejectOptions.some(
      o => o.value === currentStatusId
    );

    this.frm.patchValue(
      {
        assigned_user: this.schedule.assigned_user,
        schedule_status_id: currentStatusIsAcceptReject ? currentStatusId : undefined,
        notes: this.schedule.notes,
      },
      { emitEvent: false }
    );
  }

  openAssignedUserModal() {
    this.assignedUserPickerRef = this.dialogService.open(ModalUserPickerComponent, {
      data: {
        question_title: 'Seleziona il tecnico assegnatario',
        chosenUser: this.frm.get('assigned_user')?.value,
        registry_id: this.schedule.related_registry?.id,
        isTechnician: true,
      },
      header: 'Assegna tecnico',
      width: '900px',
    });
    this.assignedUserPickerRef.onClose.subscribe((a: { value: UserItem } | undefined) => {
      if (a) {
        this.frm.get('assigned_user')!.setValue(a.value);
      }
    });
  }

  close() {
    this.ref.close();
  }

  save() {
    this.saving = true;
    const v = this.frm.getRawValue();
    const body: ScheduleUpdateDto = {
      assigned_user_id: v.assigned_user?.id ?? undefined,
      schedule_status_id: v.schedule_status_id ?? undefined,
      notes: v.notes ?? undefined,
      // Non modificabile da questa modale: si rimanda invariato il valore attuale.
      customer_appointment: this.schedule.customer_appointment,
    };
    this.scheduleService.scheduleControllerUpdateSchedule({ id: this.schedule.id, body }).subscribe({
      next: () => {
        this.saving = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Modifica schedulazione',
          detail: 'Schedulazione modificata correttamente.',
        });
        this.ref.close({ updated: true });
      },
      error: err => {
        this.saving = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Modifica schedulazione',
          detail: err?.error?.message ?? 'Errore durante la modifica della schedulazione.',
        });
      },
    });
  }
}
